import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import show_materials_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/materials.svg';
import { img } from '@phi/components';
import { do_nothing } from '@phi/util';
import { display_show_materials_modal } from '@frontend/ui_display';
import ShowMaterialsTooltip from './ShowMaterialsTooltip';

export const ShowMaterialsIcon = show_materials_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl;
        },

        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show materials modal';
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    render() {
        return h(BarButton, {
            active: false,
            disabled: this.disabled,
            selected: this.state.tut_stage === 3,
            id: 'show-materials-modal-button',
            tippy: 'top',
            onClick: this.disabled ? do_nothing : display_show_materials_modal,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_materials_svg, this.alt),
            tooltip: ShowMaterialsTooltip,
        });
    },
});
